<script>
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import { useFlowLayoutCore } from '@rebuild/materials/shared/layout_wrapper/useFlowLayoutCore';
import FlowNavBar from '@rebuild/materials/shared/layout_wrapper/FlowNavBar.vue';
import CoreCacheRouter from '@rebuild/materials/shared/layout_wrapper/CoreCacheRouter.vue';

export default {
	name: 'FlowLayoutWrapper',
	components: {
		SmartLayoutC
	},
	setup() {
		const { showHeaderNav, filterMenus, inHomeView, getNavigationList, getCommonDataKey } = useFlowLayoutCore();

		return {
			showHeaderNav,
			filterMenus,
			inHomeView,
			getNavigationList,
			getCommonDataKey
		};
	},
	render() {
		const FlowNavBarBlock = (
			<FlowNavBar
				inHomeView={this.inHomeView}
				filterMenus={this.filterMenus}
				getNavigationList={this.getNavigationList}
				key={this.getCommonDataKey}
			/>
		);
		const Main = <CoreCacheRouter key="cache_router" />;
		const Floating = <SmartLayoutC compId="layout_floating" mode="basic" key="layout_floating" />;

		let layouts = [];
		const initRender = () => {
			if (!this.showHeaderNav) {
				layouts = [Main, Floating];
				return;
			}
			layouts = [FlowNavBarBlock, Main, Floating];
		};
		initRender();

		return <div class="flow-layout ex2rem-min-w1200-layout-next">{...layouts}</div>;
	}
};
</script>

<style lang="less" scoped>
.flow-layout {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
}
</style>
